import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

import icon1 from '../../theme/assets/svg/lp_afi_s4_icon1.svg';
import icon2 from '../../theme/assets/svg/lp_afi_s4_icon2.svg';
import icon3 from '../../theme/assets/svg/lp_afi_s4_icon3.svg';
import icon4 from '../../theme/assets/svg/lp_afi_s4_icon4.svg';
import icon5 from '../../theme/assets/svg/lp_afi_s4_icon5.svg';

import rocket from '../../theme/assets/other/lp_afi_s4_rocket.png';

const AfiS4 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}><span>{t('Поддержка после')}</span> <br/> {t('запуска')} </div>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitleRow}`}>
                            <div className={`${Styles.contentBoxItemTitleRowImgWrap}`}>
                                <img src={icon1} alt={t('Стратегическое сопровождение')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTitleRowText}`}>{t('Стратегическое сопровождение')}</div>
                        </div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Мы тесно работаем с командами, чтобы выстроить структуру запуска, согласовать ожидания и подготовиться к выходу на публичный рынок.')} <span>{t('Фокус — на прозрачности, реализации и долгосрочной ответственности.')}</span></div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitleRow}`}>
                            <div className={`${Styles.contentBoxItemTitleRowImgWrap}`}>
                                <img src={icon2} alt={t('Готовность к рынку')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTitleRowText}`}>{t('Готовность к рынку')}</div>
                        </div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Мы помогаем проектам оценить готовность к запуску, коммуникационную стратегию и ожидания после листинга.')} <span>{t('Важно запускаться в правильный момент.')}</span></div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitleRow}`}>
                            <div className={`${Styles.contentBoxItemTitleRowImgWrap}`}>
                                <img src={icon3} alt={t('Фокус на развитии после запуска')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTitleRowText}`}>{t('Фокус на развитии после запуска')}</div>
                        </div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Наша вовлечённость не заканчивается на IDO.')} <span>{t('Мы делаем акцент на непрерывности, ответственности и долгосрочном росте экосистемы после запуска.')}</span></div>
                        <div className={`${Styles.contentBoxItemRocketWrap}`}>
                            <img src={rocket} alt={t('Наша вовлечённость не заканчивается на IDO.')}/>
                        </div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitleRow}`}>
                            <div className={`${Styles.contentBoxItemTitleRowImgWrap}`}>
                                <img src={icon4} alt={t('Аудит токеномики')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTitleRowText}`}>{t('Аудит токеномики')}</div>
                        </div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Мы анализируем утилитарность токена, распределение, графики вестинга и модели стимулов, чтобы обеспечить устойчивость и справедливое участие.')} <span>{t('Без искусственных хайп-механик.')}</span></div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemTitleRow}`}>
                            <div className={`${Styles.contentBoxItemTitleRowImgWrap}`}>
                                <img src={icon5} alt={t('Структура запуска и механики')}/>
                            </div>
                            <div className={`${Styles.contentBoxItemTitleRowText}`}>{t('Структура запуска и механики')}</div>
                        </div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Мы помогаем сформировать прозрачные правила запуска, логику распределения, сроки и техническую подготовку.')} <span>{t('Каждый участник заранее знает условия участия.')}</span></div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AfiS4;




